<template>
    <span
        class="tag"
        :class="computedClass"
    >
        {{ text }}
    </span>
</template>

<script>
export default {
    name: 'Tag',
    props: {
        text: {
            type: String,
            default: '',
            required: true
        },
        context: {
            type: String,
            required: true,
            default: 'accent',
            validate (val) {
                return [
                    'accent',
                    'error',
                    'exclusive',
                    'status'
                ].includes(val)
            }
        }
    },
    computed: {
        computedClass () {
            return {
                'tag--accent': this.context === 'accent',
                'tag--exclusive': this.context === 'exclusive',
                'tag--error': this.context === 'error',
                'tag--status': this.context === 'status'
            }
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.tag {
    color: #fff;
    display: inline;
    font-size: var(--fs-small);
    font-weight: var(--fw-medium);
    line-height: 16px;
    padding: 0 16px;
    text-align: center;
    text-shadow: none;
    text-transform: uppercase;
    vertical-align: baseline;
    white-space: nowrap;

    &.tag--error {
        background-color: var(--c-error);
    }
    &.tag--accent {
        background-color: var(--c-primary);
        border-radius: 2px;
    }
    &.tag--exclusive {
        background-color: var(--c-exclusive);
        border-radius: 2px;
    }
    &.tag--status {
        background-color: #808689;
        border-radius: 2px;
        padding: 0 8px;
    }
}
</style>
